import { ProcessedWidget } from '../../assets/modules/hawk/processWidgets/processWidget';
import { dealDataToProducts } from '../entry/dealDataToProducts';
import { EventName, FullyQualifiedMessageName, HawkEvent } from '../entry/sendEvent';

import { BaseEvent } from './BaseEvent';

export class WidgetsLoaded extends BaseEvent {
  public hawkEvent: HawkEvent;

  constructor({ processedWidgets }: { processedWidgets: ProcessedWidget[] }) {
    super();
    this.hawkEvent = {
      name: EventName.WIDGETS_LOADED,
      fullyQualifiedMessageName: FullyQualifiedMessageName.WIDGETS_LOADED,
      data: {
        fieWidgetsVersion: this.fieWidgetsVersion,
        context: {
          page: this.page,
          content: this.content,
          site: this.site,
          experiment: this.experiment,
          user: this.user,
        },
        loadedAt: new Date().toISOString(),
        widgets: processedWidgets.map((widget) => ({
          type: widget.type,
          result: widget.result,
          products: dealDataToProducts(widget.props.dealData),
        })),
      },
    };
  }
}
